import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO } from "../data.js";

// Blocco "Guide" con link contestuali (titolo + descrizione) verso le guide.
// Serve a dare peso interno alle guide e a far capire a Google di cosa parla
// ciascuna. `exclude` = slug da non mostrare (es. la pagina corrente).
export default function GuideLinks({ exclude }) {
  const items = GUIDES.filter(g => g.slug !== exclude);
  return (
    <section className="sec" style={{ background: "var(--bg)" }}>
      <div className="wrap">
        <div className="tc">
          <div className="chip g">Guide</div>
          <h2 className="h2">Guide per chi gestisce un noleggio</h2>
        </div>
        <div className="fg">
          {items.map(g => (
            <article className="fc" key={g.slug}>
              <h3 className="ft">
                <Link to={`/${g.slug}`} style={{ textDecoration: "none", color: "inherit" }}>{g.label}</Link>
              </h3>
              <p className="fd">{PAGE_SEO[g.slug]?.description}</p>
              <Link to={`/${g.slug}`} style={{ textDecoration: "none", fontWeight: 700, fontSize: ".85rem", color: "var(--blue)" }}>
                Leggi la guida →
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
